
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/cookies",
      function () {
        return require("private-next-pages/[lang]/legal/cookies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/cookies"])
      });
    }
  